import { gql } from '@apollo/client';

export const LOGIN = gql`
  query LOGIN($input: AuthInput!) {
    signIn(input: $input) {
      access_token
    }
  }
`;

export const GETLASTUPLOADEDFILE = gql`
  query GetLastUpdated($input: GetLastUploadedFileInput!) {
    getLastUploaded(input: $input) {
      name
      path
      boxName
      isLatest
    }
  }
`;

export const DOWNLOAD_LAST = gql`
  query DownloadLastUploaded($input: GetLastUploadedFileInput!) {
    downloadLastUploaded(input: $input) {
      name
      body
      ext
    }
  }
`;

export const GETALLLASTUPLOADED = gql`
  query GetAllLastUploaded {
    getAllLastUploaded {
      name
      path
      boxName
      isLatest
    }
  }
`;

export const PROCESSFILES = gql`
  query ProcessUploadedFiles {
    processUploadedFiles
  }
`;

export const LASTJOB = gql`
  query GetLastJob {
    getLastJob {
      state
      errorField
      boxName
      isLatest
    }
  }
`;
